import React from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import { history } from 'store';
import AddSurveyGroup from '../../AddSurveyGroup/index';

class SurveyGroupRow extends React.Component {

    onSurveyGroupOptionToggle = () => {
        this.setState({ menuState: !this.state.menuState });
    };

    onSurveyGroupClose = () => {
        this.setState({ addSurveyGroupState: false });
    };
    onDeleteSurveyGroup = (group) => {
        this.setState({ addSurveyGroupState: false });
        this.props.onDeleteSurveyGroup(group);
    };
    onEditSurveyGroup = () => {
        this.setState({ menuState: false, addSurveyGroupState: true });
    };
    onSurveyGroupQuestions = (group) => {
        this.setState({ addSurveyGroupState: false });
        this.props.onSurveyGroupQuestions(group);
        history.push('/app/survey-group-question/default');
    };

    constructor() {
        super();
        this.state = {
            menuState: false,
            addSurveyGroupState: false,
        }
    }

    render() {
        const { surveyGroup, addFavouriteSurveyGroup, onSurveyGroupSelect, onSaveSurveyGroup, showSurveyGroupLoader } = this.props;
        const { menuState, addSurveyGroupState } = this.state;
        const { name, starred, thumb } = surveyGroup;
        const options = [
            'Edit',
            'Delete',
            'Questions',
        ];
        return (

            <div className="contact-item  align-items-center">
                <div className="form-control-checkbox d-flex">
                    <div className="form-checkbox">
                        <input type="checkbox"
                            checked={surveyGroup.selected}
                            value="checked"
                            onClick={() => {
                                onSurveyGroupSelect(surveyGroup);
                            }}
                            onChange={() => {
                            }}
                        />

                        <span className="check">
                            <i className="zmdi zmdi-check zmdi-hc-lg" />
                        </span>
                    </div>
                </div>

                <div className="col-auto px-1 actions d-none d-xs-flex">
                    <span className="icon-btn" onClick={() => {
                        addFavouriteSurveyGroup(surveyGroup);
                    }}>
                        {starred ? <i className="zmdi zmdi-star" /> : <i className="zmdi zmdi-star-outline" />}
                    </span>
                </div>
                {(thumb === null || thumb === '') ?
                    <div className="rounded-circle size-40 bg-blue text-center text-white mx-1 mx-md-3"
                        style={{ fontSize: 20 }}>
                        {name ? name.charAt(0).toUpperCase() : ''}
                    </div> :
                    <img className="rounded-circle size-40 mx-1 mx-md-3" alt={name} src={thumb} />
                }
                <div className="col con-inf-mw-100">
                    <p className="mb-0">
                        <span className="text-truncate group-name">
                            {name}
                        </span>
                    </p>
                </div>

                <div>
                    <Dropdown isOpen={menuState}
                        toggle={this.onSurveyGroupOptionToggle.bind(this)}>
                        <DropdownToggle tag="span">
                            <span className="icon-btn text-grey pointer">
                                <i className="zmdi zmdi-more-vert zmdi-hc-lg" />
                            </span>
                        </DropdownToggle>

                        <DropdownMenu>
                            {options.map(option =>
                                <DropdownItem key={option} onClick={() => {
                                    if (option === 'Edit') {
                                        this.onEditSurveyGroup();
                                    } else if (option === 'Delete') {
                                        this.onDeleteSurveyGroup(surveyGroup);
                                    } else if (option === 'Questions') {
                                        this.onSurveyGroupQuestions(surveyGroup);
                                    }
                                }
                                }>
                                    {option}
                                </DropdownItem>,
                            )}
                        </DropdownMenu>

                    </Dropdown>

                    {addSurveyGroupState &&
                        <AddSurveyGroup open={addSurveyGroupState} surveyGroup={surveyGroup} onSaveSurveyGroup={onSaveSurveyGroup}
                            onSurveyGroupClose={this.onSurveyGroupClose} onDeleteSurveyGroup={this.onDeleteSurveyGroup}
                            showSurveyGroupLoader={showSurveyGroupLoader} />}
                </div>
            </div>
        )
    }
}

export default SurveyGroupRow;


// WEBPACK FOOTER //
// ./components/Agile/SurveyGroup/SurveyGroupList/SurveyGroupRow/index.js